module.exports = __webpack_public_path__ + "static/img/takitaLogo.19c399a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/takitaLogo.png
// module id = UObf
// module chunks = 1